export default __webpack_public_path__ + "static/media/Vikendice-COVER.fe34aaf5.jpg";